module.exports = __webpack_public_path__ + "static/media/vsc.ba526c82.svg";